import { t } from 'i18next';
import { fDate } from 'src/utils/format-time';

export const PAGE_PADDING_X = '24px';
export const CHART_HEIGHT = 484;
export const CHART_INNER_HEIGHT = 360;
export const SECTION_GAP = 2;

// Selected-country underline — brand purple, matching the Explore CountryBar.
export const COUNTRY_UNDERLINE = '#9982CC';

export const ColorSchema = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
} as const;

export const TRAFFIC_BRANDED_FORMAT = [
  { value: 'Value', label: 'dashboard.global.value' },
  { value: 'Percent', label: 'dashboard.global.percent' },
];

// Branded Traffic Distribution palette (Figma — Signal 2026 Q2 rebranding)
export const DISTRIBUTION_COLORS = {
  organic: '#18a055',
  searchPaid: '#ffb700',
  shoppingPaid: '#ff8c00',
  pmaxPaid: '#FFE299',
  uncaptured: '#f1f1f1',
};

// Colors are mapped dynamically to the series built in FunnelDistributionChart.
// Supported series:
// - Organic Traffic
// - Search Paid
// - Shopping Paid
// - PMax
// - Uncaptured Brand Traffic
//
// This avoids color mismatches when Shopping or PMax are conditionally displayed.
export const getDistributionColors = (series: any[]) =>
  series.map((s) => {
    switch (s.name) {
      case t('dashboard.brandTraffic.organicBrandTraffic'):
        return DISTRIBUTION_COLORS.organic;

      case t('dashboard.brandTraffic.searchPaid'):
        return DISTRIBUTION_COLORS.searchPaid;

      case t('dashboard.brandTraffic.shoppingPaid'):
        return DISTRIBUTION_COLORS.shoppingPaid;

      case t('dashboard.brandTraffic.pmaxPaid'):
        return DISTRIBUTION_COLORS.pmaxPaid;

      case t('dashboard.brandTraffic.uncapturedBrandTraffic'):
        return DISTRIBUTION_COLORS.uncaptured;

      default:
        return DISTRIBUTION_COLORS.uncaptured;
    }
  });

// Branded Traffic Performance palette (Figma — Signal 2026 Q2 rebranding)
// Bars share the Distribution paid palette; lines use the brand purple.
export const PERFORMANCE_COLORS = {
  blendedCtr: '#5119b7',
  searchAdCost: '#ffb700',
  shoppingAdCost: '#ff8c00',
  pmaxAdCost: '#FFE299',
  adCost: '#ffb700',
  blendedCpc: '#e4d9f8',
};

export interface TimeSeriesData {
  adClicks: number;
  adCost: number;
  blendedCtr: number | null;
  brandTraffic: number;
  date_interval: string;
  organicClicks: number;
  organicSearches: number;
  year_week?: string;
  year_month?: string;
  banking_date?: string;
  [key: string]: any;
}

export const formatLabels = (data: TimeSeriesData[], timestep: string, lang: string): string[] =>
  data.map((item) => {
    let dateStr = '';
    switch (timestep) {
      case 'year_week':
        dateStr = item.year_week || item.date_interval || '';
        break;
      case 'year_month':
        dateStr = item.year_month || item.date_interval || '';
        break;
      default:
        dateStr = item.date_interval || '';
    }
    return fDate(dateStr, 'yyyy-MM-dd');
  });
